import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    borderRadius: 10,
    marginBottom: 28,
    backgroundColor: "#fffbf6",
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    position: 'relative'
  },

  bodyTitle: {
    color: "#000000",
    fontFamily: "Montserrat",
    fontSize: '3em',
    fontWeight: "500",
    textAlign: 'center',
    marginTop: 31,
    maxWidth: 221,
  },

  title: {
    color: "#FFF",
    fontSize: 22,
    fontWeight: "700",
    fontFamily: "Montserrat",
    textAlign: 'center',
    maxWidth: '290px',
    wordBreak: "break-word",
    paddingTop: 22
  },

  disclaimer: {
    color: "#FFF",
    fontSize: 9,
    fontWeight: "400",
    fontFamily: "Montserrat",
    wordBreak: "break-word",
    paddingBottom: 20,
    paddingLeft: 10,
    paddingRight: 5
  },

  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  bodyText: {
    maxWidth: '290px',
    color: "rgba(0,0,0,0.74)",
    fontWeight: '400',
    fontFamily: "Montserrat",
    fontSize: '16px',
    wordBreak: "break-word",
    '& p': {
      maxWidth: '290px',
      color: "rgba(0,0,0,0.74)",
      fontWeight: '400',
      fontFamily: "Montserrat",
      fontSize: '16px',
      wordBreak: "break-word",
    }
  },

  bodyTextContainer: {
    display: 'flex',
    marginBottom: 2,
    width: 284,
    position: 'relative'
  },

  footer: {
    padding: '0em 45px 0em'
  },

  logo: {
    width: '100%',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12
  },
 
  openIcon: {
    marginLeft: 10,
    [theme.breakpoints.down('md')]: {
      right: "0px",
    },
  },

  footerSection: {
    position: 'absolute',
    marginTop: '284px',
    color: "#4D4D4D",
    fontWeight: '400',
    fontFamily: "Montserrat",
    fontSize: 10
  },

  clickHere: {
    fontWeight: '700',
    fontFamily: "Montserrat",
    fontSize: 10,
    textDecoration: 'underline',
    cursor: 'pointer'
  },

  footer: {
    padding: '1.2em 4em 1.2em'
  },

  btn: {
    width: '100%',
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    height: 34
  },

  resetButton: {
    fontFamily: 'Montserrat',
    letterSpacing: '0.36px',
    fontWeight: '700',
    marginRight: '25px',
    width: '100%',
    height: '34px',
    border: "2px solid",
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
    borderColor: theme.palette.primary.main,
    '&:hover': {
      border: "2px solid",
      borderColor: theme.palette.primary.main,
    },
  },

  call: {
    position: 'absolute',
    top: '24px',
    left: '150px',
    color: 'white',
    fontSize: 16,
    fontFamily: "Montserrat",
    fontWeight: "700",
    [theme.breakpoints.down('sm')]: {
       left: '144px'
    },
 },

 numberStyle: {
    color: '#ffffff',
    fontSize: '22px',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: "20px"
    },
  }

}));
